// extracted by mini-css-extract-plugin
export default {"divider":"Mint_divider__ongcJ","buttonsWrapper":"Mint_buttonsWrapper__snyPM"};